import { useState } from 'react';
import { Llave } from './iconos';

/**
 * Muestra el enlace de invitación que el servidor devuelve **solo en desarrollo**.
 *
 * ── Por qué existe ──
 * El correo saliente todavía no está: falta el SMTP de Copathy (M10). Sin esto no
 * hay forma de probar la activación de punta a punta, ni de darle acceso a nadie
 * mientras tanto.
 *
 * ⚠️ **En producción el servidor no devuelve `enlaceDev`**, así que este bloque no
 * aparece — es `enlaceParaDev` quien lo decide, no la interfaz. Si algún día se ve
 * en producción, el defecto está en el servidor: un enlace de activación en
 * pantalla es una credencial a la vista de quien pase por detrás.
 */
export function EnlaceDeInvitacion({
  enlace,
  nombre,
  alCerrar,
}: {
  enlace: string;
  /** De quién es. Con un reenvío masivo hay varios a la vez y hay que distinguirlos. */
  nombre?: string | undefined;
  alCerrar: () => void;
}) {
  const [copiado, setCopiado] = useState(false);

  return (
    <div className="mb-5 rounded-2xl border border-amber-200 bg-amber-50 p-4">
      <div className="flex flex-wrap items-start gap-3">
        <Llave size={18} className="mt-0.5 shrink-0 text-amber-700" />
        <div className="min-w-0 flex-1">
          <p className="font-semibold text-amber-900">
            Enlace de activación{nombre ? ` para ${nombre}` : ''} — solo mientras no haya correo saliente
          </p>
          <p className="mt-0.5 text-sm text-amber-800">
            Pásaselo a la persona por un canal privado. Vence en 7 días y sirve una sola vez.
          </p>
          <p className="mt-2 break-all rounded-xl bg-white px-3 py-2 font-mono text-xs text-marino-700">
            {enlace}
          </p>
          <div className="mt-2 flex gap-3">
            <button
              type="button"
              onClick={() => {
                void navigator.clipboard?.writeText(enlace);
                setCopiado(true);
                setTimeout(() => setCopiado(false), 2000);
              }}
              className="text-sm font-semibold text-amber-900 transition hover:underline"
            >
              {copiado ? 'Copiado' : 'Copiar enlace'}
            </button>
            <button
              type="button"
              onClick={alCerrar}
              className="text-sm font-semibold text-amber-700 transition hover:underline"
            >
              Ocultar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
